import React from 'react';

import { EventFrame } from '@vlabs/monokit/entities/events/event-frame/EventFrame';
import { EventTopMatchHistory } from '@vlabs/monokit/entities/events/event-top-match-history';
import { EventMap } from '@vlabs/monokit/entities/events/map';
import { EventTopMatchPanel } from '@vlabs/monokit/widgets/event-top-match-panel';

import st from './DetectionAndMatchEventView.module.sass';
import { useSelectedWorkspaceEvent } from '../useSelectedWorkspaceEvent';

export function DetectionAndMatchEventView(): React.JSX.Element {
  const { setSelectedEvent, event } = useSelectedWorkspaceEvent();

  const onEventSelect = (historyEvent) => {
    setSelectedEvent(historyEvent);
  };

  return (
    <div className={st.EventInfo}>
      <EventFrame event={event} />
      <EventMap event={event} />
      <EventTopMatchPanel event={event} />
      <EventTopMatchHistory
        event={event}
        onEventSelect={onEventSelect}
      />
    </div>
  );
}
